"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSpring;
function createSpring(target, springK, frictionK) {
  return function Spring(xParam, vParam, secPerStep, elapsed) {
    var x = xParam;
    var v = vParam;
    if (x !== target) {
      v -= ((x - target) * springK + frictionK * v) * secPerStep;
    }
    x += v * secPerStep;
    var shouldStop = Math.abs(x - target) / target < 0.00001 && Math.abs(v) < 0.00001;
    return [shouldStop ? target : x, v, shouldStop];
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/steppers/createSpring.js
// module id = 42
// module chunks = 0